module.exports = __webpack_public_path__ + "static/media/giftPile.b8e1c883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/giftPile.svg
// module id = 893
// module chunks = 51